import React from "react";
import { TouchableOpacity } from "react-native";
import CustomText from "@components/CustomText";
import { colors } from "@constants/theme";

const SortingTabButton = ({ title, isActive, onPress }) => {
  return (
    <TouchableOpacity
      testID="sd-sorting-tab-button"
      activeOpacity={0.8}
      style={{
        flex: 1,
        alignItems: "center",
        borderBottomWidth: 2,
        borderBottomColor: isActive ? colors.primary : "white",
        paddingVertical: 4,
      }}
      onPress={onPress}
    >
      <CustomText
        variant="title_16"
        style={{
          paddingVertical: 6,
          color: isActive ? colors.black : colors.mediumBlacklightBlack,
        }}
      >
        {title}
      </CustomText>
    </TouchableOpacity>
  );
};

export default SortingTabButton;
